import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { InstallCard } from "@/components/InstallCard";

const Icon = ({ children }) => (
  <svg viewBox="0 0 48 48" width="40" height="40" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">{children}</svg>
);

const ICONS = {
  apero: <Icon><path d="M15 14l6 2-3 11a4 4 0 01-5-1.5z" /><path d="M33 14l-6 2 3 11a4 4 0 005-1.5z" /><path d="M15.5 26.5L12 38M32.5 26.5L36 38M9 38h6M33 38h6" /><path d="M24 6v4M19 7.5l1.5 3M29 7.5l-1.5 3" /></Icon>,
  affaires: <Icon><rect x="8" y="16" width="32" height="22" rx="3" /><path d="M18 16v-4a2 2 0 012-2h8a2 2 0 012 2v4M8 25h32" /><circle cx="24" cy="25" r="2" /></Icon>,
  privees: <Icon><path d="M24 15s-5-3.5-5-6.5a2.7 2.7 0 015-1.4 2.7 2.7 0 015 1.4C29 11.5 24 15 24 15z" /><circle cx="24" cy="21" r="3.5" /><circle cx="14" cy="23" r="3" /><circle cx="34" cy="23" r="3" /><path d="M17 38v-4a7 7 0 0114 0v4M7 36v-2a6 6 0 019-5M41 36v-2a6 6 0 00-9-5" /></Icon>,
  agenda: <Icon><rect x="9" y="11" width="30" height="28" rx="3" /><path d="M9 19h30M17 7v7M31 7v7" /><path d="M24 23l1.9 3.9 4.1.5-3 2.9.8 4.2-3.8-2-3.8 2 .8-4.2-3-2.9 4.1-.5z" /></Icon>,
  diamant: <Icon><path d="M14 12h20l7 9-17 18L7 21z" /><path d="M7 21h34M19 12l-3 9 8 18 8-18-3-9M16 21l8-9 8 9" /></Icon>,
};

const LINKS = [
  { id: "apero", label: ["APÉRO", "RENCONTRE"], to: "/events?cat=rencontres" },
  { id: "affaires", label: ["RENCONTRE", "D'AFFAIRES"], to: "/events?cat=affaires" },
  { id: "privees", label: ["RENCONTRES", "PRIVÉES"], to: "/events?cat=rencontres" },
  { id: "agenda", label: ["NOS PROCHAINS", "ÉVÉNEMENTS"], to: "/events" },
  { id: "diamant", label: ["NOS", "EXPÉRIENCES"], to: "/experiences" },
];

export default function Home() {
  return (
    <div data-testid="home-page" className="relative min-h-screen pb-32 md:min-h-0 md:mx-auto md:max-w-xl md:px-6 md:py-10 lg:grid lg:max-w-none lg:grid-cols-[minmax(0,480px)_1fr] lg:items-center lg:gap-16 lg:px-8">
      <div className="hidden justify-center pb-8 pt-2 md:flex lg:col-span-2">
        <img src="/img/logo.webp" alt="enjoythismoment" data-testid="home-top-logo" className="h-20 w-auto lg:h-24" />
      </div>
      <div className="relative md:overflow-hidden md:rounded-[32px] md:border md:border-[#E6A45D]/30">
        <img src="/img/hero.webp" alt="enjoythismoment — Event & Instant, Carine" data-testid="home-hero" fetchPriority="high" width="634" height="768" className="block h-auto w-full select-none" draggable={false} />
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-[#090806] via-[#090806]/70 to-transparent md:h-24" />
      </div>
      <div className="md:mt-10 md:space-y-10 lg:mt-0">
        <div className="hidden md:block">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#E6A45D]">Event &amp; Instant</p>
          <h1 className="mt-4 text-4xl font-semibold leading-tight text-[#F7F4EE] lg:text-5xl">Des soirées et des rencontres <span className="gold-text">d'exception</span></h1>
          <p className="mt-4 max-w-md text-base text-[#F7F4EE]/70">Apéros rencontre, afterworks, dégustations et Instants sur mesure, imaginés par Carine.</p>
        </div>
        <div className="no-scrollbar relative -mt-8 flex snap-x overflow-x-auto px-2 md:mt-0 md:overflow-visible md:px-0">
          {LINKS.map((l, i) => (
            <Link key={l.id} to={l.to} data-testid={`home-link-${l.id}`} style={{ animationDelay: `${120 + i * 60}ms` }}
              className={`fade-up group flex min-w-[76px] flex-1 snap-start flex-col items-center gap-3 px-1 ${i ? "border-l border-[#E6A45D]/15" : ""}`}>
              <span className="gold-ring flex h-[66px] w-[66px] items-center justify-center rounded-full bg-[#090806]/40 text-[#F8C872] backdrop-blur-sm transition-transform duration-200 group-hover:scale-105 group-active:scale-95 lg:h-[80px] lg:w-[80px]">
                {ICONS[l.id]}
              </span>
              <span className="text-center text-[10.5px] font-medium leading-[1.35] text-[#F7F4EE] lg:text-xs">{l.label[0]}<br />{l.label[1]}</span>
            </Link>
          ))}
        </div>
        <div className="px-5 pt-8 md:px-0 md:pt-0">
          <Link to="/events" data-testid="home-cta-button" className="btn-gold fade-up h-[60px] w-full whitespace-nowrap px-4 text-[12px] !tracking-[0.03em] md:max-w-lg md:text-sm" style={{ animationDelay: "450ms" }}>
            Participer à nos prochains événements <ArrowRight size={18} strokeWidth={2} />
          </Link>
        </div>
        <InstallCard />
      </div>
    </div>
  );
}
